import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    NgZone,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ApiResponse, Taxe, TaxeService} from "../../../../parametre/taxe-tva/parametre-taxe/taxe.service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {ParametreService} from "../../../../parametre/main-parametre/parametre.service";
import {NgForm} from "@angular/forms";
//import { Taxe, TaxeService, ApiResponse } from './taxe.service';


@Component({
    selector: 'app-add-taxe',
    templateUrl: './add-taxe.component.html',
    styleUrls: ['./add-taxe.component.scss']
})
export class AddTaxeComponent implements OnInit {
    @Output() taxeAdded = new EventEmitter<any>();
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
    modalRef: NgbModalRef | null = null;
    isLoading: boolean = false;
    TaxeList: Taxe[] = [];

    TaxeData: Taxe = {
        id: 0,
        client_id: 1,
        station_id: 1,
        nom: '',
        label: '',
        valeur: 1,
        valeur_fixe: false,
        valeur_pourcentage: true,
        applique_avant_tva: false,
        applique_apres_tva: false,
        taxe_applique_sur_produits: false,
        type: '+',
        applique_sur_product: false,
        statut: true
    };

    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    clientId = this.currentUser?.id;
    stationId = this.currentUser?.stations?.[0]?.id;

    constructor(private modalService: NgbModal,
                private taxeService: TaxeService,
                private toastr: ToastrService,
                private router: Router,
                private cdr: ChangeDetectorRef,
                private ngZone: NgZone) {
    }

    ngOnInit(): void {
    }

    openModal(): Promise<any> {
        return new Promise((resolve) => {
            const options: NgbModalOptions = {
                size: 'lg',
                windowClass: 'custom-modal-width',
                centered: true,
                backdrop: 'static',
                keyboard: false
            };
            this.modalRef = this.modalService.open(this.modalTemplate, options);

            // Résoudre la promesse quand le modal se ferme avec une taxe
            this.modalRef.result.then(
                (result: any) => resolve(result),
                () => resolve(null)
            );
        });
    }

    cancelModal(): void {
       // this.toastr.info('Action annulée', 'Information');
        this.isLoading = false;
        if (this.modalRef) {
            this.modalRef.dismiss('Cancel click');
            this.modalRef = null;
        }
    }
    modalType: 'ajouter' | 'update' | 'etat' = 'ajouter';
    newStatut: boolean | null = null;
    onSubmit(form: NgForm): void {
        // 1. Initial Checks
        if (this.stationId === null) {
            this.toastr.error('Aucune station disponible.', 'Erreur');
            this.isLoading = false;
            return;
        }

        if (!this.modalRef) {
            this.toastr.error('Erreur: modal non initialisé.', 'Erreur');
            this.isLoading = false;
            return;
        }

        // Check if the modal is explicitly for addition/creation.
        // If not, we block the action.
        if (this.modalType !== 'ajouter') {
            this.toastr.error('Action non autorisée. Veuillez utiliser le formulaire d\'ajout.', 'Erreur');
            this.isLoading = false;
            return;
        }

        // 2. Form Validation Check
        if (!form.valid) {
            this.toastr.error('Veuillez remplir tous les champs requis.', 'Erreur');
            this.isLoading = false;
            return;
        }

        // 3. Create (ajouter) Logic
        this.isLoading = true;
        const taxe = { ...this.TaxeData }; // Assuming this is the data object from your form

        this.taxeService.createTaxe(taxe, this.stationId).subscribe({
            next: (response: ApiResponse) => {
                this.isLoading = false;
                if (response?.success) {
                    let newTaxe: any;

                    // Extract the created object, prioritizing 'taxes[0]' then 'taxe'
                    if (response.taxes && Array.isArray(response.taxes)) {
                        newTaxe = response.taxes[0];
                    } else if (response.taxe) {
                        newTaxe = response.taxe;
                    } else {
                        this.toastr.error('Réponse inattendue du serveur: aucun taxe retourné.', 'Erreur');
                        return;
                    }

                    this.updateTaxeList(newTaxe); // Update list in the parent component/service
                    this.taxeAdded.emit(newTaxe); // Notify the parent component

                    // Ensure UI updates are detected
                    this.ngZone.run(() => {
                        this.cdr.detectChanges();
                        this.toastr.success('Taxe ajoutée avec succès', 'Succès');
                    });

                    // Close the modal and reset reference
                    this.modalRef!.close(newTaxe);
                    this.modalRef = null;

                } else {
                    this.toastr.error('Échec de l\'ajout de la taxe: ' + (response.message || 'Réponse inattendue'), 'Erreur');
                }
            },
            error: (error) => {
                this.isLoading = false;
                this.toastr.error('Erreur lors de l\'ajout: ' + (error.message || 'Erreur inconnue'), 'Erreur');
            }
        });
    }

    private updateTaxeList(updatedTaxe: Taxe): void {
        const index = this.TaxeList.findIndex(t => t.id === updatedTaxe.id);
        if (index !== -1) {
            this.TaxeList = [
                ...this.TaxeList.slice(0, index),
                { ...this.TaxeList[index], ...updatedTaxe },
                ...this.TaxeList.slice(index + 1)
            ];
        } else {
            this.TaxeList = [...this.TaxeList, updatedTaxe];
        }
        this.ngZone.run(() => {
            this.cdr.detectChanges();
        });
    }

    incrementValue(): void {
        this.TaxeData.valeur = (this.TaxeData.valeur || 1) + 1;
    }

    decrementValue(): void {
        if (this.TaxeData.valeur > 0) {
            this.TaxeData.valeur -= 1;
        }
    }

    onValueChange(): void {
        // Implementation for value change if needed
    }

    isValueTooLong(): boolean {
        // Implementation for value length check if needed
        return false;
    }
}
